import { Button } from 'components';

import styled from 'styled-components';
import { FrameHeaderHeight } from 'styles/constants';
import { themes } from 'styles/themes/wikifactoryNew';

const drawActiveTriangleUnderCSS = () => `
  position: relative;
  // overflow: visible;
  &::after {
    content: '';
    position: absolute;
    right: calc(50% - 13px);
    bottom: -9px;

    border-top: 8px solid ${themes.color.wfGrey200};
    border-left: 13px solid transparent;
    border-right: 13px solid transparent;
  }
`;

export const ButtonStyled = styled(Button)`
  height: ${FrameHeaderHeight}px;
  border: none;
  color: black;
  padding: ${props => props.theme.spacing.default};
  align-items: center;
  border-radius: 0;
  font-size: ${props => props.theme.font.size.small};

  &:hover {
    border-color: currentColor;
    text-decoration: none;
  }
`;

export const MakeButtonStyled = styled(ButtonStyled)`
  min-width: auto;
  padding: 0 1rem;
  color: ${props => props.theme.color.wfBlue};

  &:hover {
    opacity: 0.7;
  }

  ${props => props.active && drawActiveTriangleUnderCSS()}
`;

// prettier-ignore
export const DiffButtonStyled = styled(ButtonStyled)`
  min-width: auto;
  padding: 0 1rem;
  color: ${props => props.theme.color.wfPurple};

  &:hover {
    opacity: 0.7;
  }

  ${props => props.active && drawActiveTriangleUnderCSS()}
`;

// prettier-ignore
export const ChatButtonStyled = styled(ButtonStyled)`
  min-width: auto;
  padding: 0 1rem;
  &:hover {
    opacity: 0.7;
  }

  ${props => props.active && drawActiveTriangleUnderCSS()}
`;
